import { Card, CardContent } from "@/components/ui/card";
import { MetricDelta } from "./MetricDelta";

type StatGridCardProps = {
  label: string;
  value: string;
  delta?: number | null;
  sub?: string;
};

export function StatGridCard({ label, value, delta, sub }: StatGridCardProps) {
  const hasDelta = typeof delta !== "undefined";
  const hasFooter = hasDelta || Boolean(sub);

  return (
    <Card className="border-border/80 bg-card/95 shadow-none">
      <CardContent className="space-y-1.5 p-3">
        <div className="text-[0.62rem] font-mono uppercase tracking-wide text-muted-foreground">{label}</div>
        <div className="text-xl font-semibold tracking-tight md:text-2xl">{value}</div>
        {hasFooter ? (
          <div className="flex items-center gap-2">
            {hasDelta ? <MetricDelta value={delta} /> : null}
            {sub ? <span className={`text-[0.68rem] text-muted-foreground ${hasDelta ? "ml-auto" : ""}`}>{sub}</span> : null}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
